import * as angular from "angular";
import { ExportService } from "../services/export.service";

export class ExportDataProvider {
    private $q: any;
    private service: ExportService;

    constructor($q: any, ExportService: ExportService) {
        this.$q = $q;
        this.service = ExportService;
    }

    all(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.all().then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    canvasses(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.canvasses(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    walkingList(gid: string, offset: number): Promise<any> {
        const deferred = this.$q.defer();
        this.service.walkingList({ gid: gid, offset: offset }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    geoJson(gid: string): Promise<any> {
        const deferred = this.$q.defer();
        this.service.geoJson({ gid: gid }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    geoJsonBulk(payload: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.geoJson(payload).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    kml(gid: string): Promise<any> {
        const deferred = this.$q.defer();
        this.service.kml({ gid: gid }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    kmlBulk(payload: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.kml(payload).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    shapefile(gid: string): Promise<any> {
        const deferred = this.$q.defer();
        this.service.shapefile({ gid: gid }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    shapefileBulk(payload: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.shapefile(payload).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    create(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.create(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("ExportDataProvider", ExportDataProvider);
